import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { selectedCraftAtom, selectedCraftingInnerTabAtom, selectedTierAtom } from '@/atoms'
import { allRecipes, isDesynthesisRecipe } from '@/data'
import type { Recipe } from '@/types'

export function useRecipeList(): Recipe[] {
  const craft = useAtomValue(selectedCraftAtom)
  const innerTab = useAtomValue(selectedCraftingInnerTabAtom)
  const tier = useAtomValue(selectedTierAtom)

  return useMemo(
    () =>
      allRecipes.filter((r) => {
        if (r.craftType !== craft) return false
        if (tier !== null && r.tierIndex !== tier) return false

        const isDesynth = isDesynthesisRecipe(r)
        return innerTab === 'desynthesis' ? isDesynth : !isDesynth
      }),
    [craft, innerTab, tier]
  )
}
